import { render, staticRenderFns } from "./teamMemberDetails.vue?vue&type=template&id=b8446c26"
import script from "./teamMemberDetails.vue?vue&type=script&lang=js"
export * from "./teamMemberDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports